module.exports = __webpack_public_path__ + "img/111.fecc9154.jpg";